import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { MdAssessment, MdChevronRight, MdViewList } from 'react-icons/md'

import Colors from '../commons/Colors'
import Modal from '../commons/components/ModalResponsive'
import ReportsModal from './ReportsModal'

export const DETAILED_ORDER_REPORT_PATH = '/relatorios/pedidos-detalhados'

/**
 * Tela de escolha entre os dois relatórios do menu "Relatórios".
 *
 * O relatório analítico (Painel de Pedidos) continua sendo o `ReportsModal`
 * existente, renderizado sem nenhuma alteração; o detalhado é uma tela própria.
 */
const ReportChooserModal = ({ onCloseReportsModal }) => {
    const history = useHistory()
    const [showAnalyticalReport, setShowAnalyticalReport] = useState(false)

    const goToDetailedReport = () => {
        onCloseReportsModal()
        history.push(DETAILED_ORDER_REPORT_PATH)
    }

    if (showAnalyticalReport)
        return <ReportsModal onCloseReportsModal={onCloseReportsModal} />

    return (
        <Modal visible={true} onClose={onCloseReportsModal}>
            <ModalHeader>
                <ModalTitle>Relatórios</ModalTitle>

                <ModalSubtitle>
                    Escolha o relatório que deseja consultar.
                </ModalSubtitle>
            </ModalHeader>

            <ModalContent>
                <ReportOption
                    data-testid="report-option-analytical"
                    onClick={() => setShowAnalyticalReport(true)}
                >
                    <OptionIconContainer>
                        <MdAssessment size={28} color={Colors.orange} />
                    </OptionIconContainer>

                    <OptionTexts>
                        <OptionTitle>Painel de Pedidos</OptionTitle>
                        <OptionDescription>
                            Relatório analítico em PDF, com os indicadores
                            consolidados da fábrica no período.
                        </OptionDescription>
                    </OptionTexts>

                    <MdChevronRight size={24} color={Colors.blueGrey} />
                </ReportOption>

                <ReportOption
                    data-testid="report-option-detailed"
                    onClick={goToDetailedReport}
                >
                    <OptionIconContainer>
                        <MdViewList size={28} color={Colors.orange} />
                    </OptionIconContainer>

                    <OptionTexts>
                        <OptionTitle>Relatório Detalhado</OptionTitle>
                        <OptionDescription>
                            Lista pedido a pedido, com produtos, valores e
                            exportação para Excel.
                        </OptionDescription>
                    </OptionTexts>

                    <MdChevronRight size={24} color={Colors.blueGrey} />
                </ReportOption>
            </ModalContent>
        </Modal>
    )
}

const ModalHeader = styled.div`
    padding: 16px;
    background-color: ${Colors.lightBlueGreyFour};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
`

const ModalTitle = styled.span`
    display: block;
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: ${Colors.black};
`

const ModalSubtitle = styled.span`
    display: block;
    margin-top: 8px;
    font-family: Roboto;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: ${Colors.brownishGrey};
`

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    max-width: 560px;
`

const ReportOption = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    background-color: ${Colors.white};
    border: solid 1px ${Colors.lightBlueGreyFour};
    border-radius: 4px;
    padding: 16px;
    cursor: pointer;

    & + & {
        margin-top: 12px;
    }

    :hover {
        border-color: ${Colors.orange};
        background-color: ${Colors.opacityOrange};
    }
`

const OptionIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
`

const OptionTexts = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const OptionTitle = styled.span`
    font-family: Roboto;
    font-size: 15px;
    font-weight: bold;
    color: ${Colors.black};
`

const OptionDescription = styled.span`
    margin-top: 4px;
    font-family: Roboto;
    font-size: 13px;
    line-height: 1.4;
    color: ${Colors.brownishGrey};
`

export default ReportChooserModal
